import {
    StyledCalendarMonthTitle,
    StyledCalendarNav,
    StyledCalendarNavMonthYearSelectorsGrid
} from '@/components/commons/calendar/calendar-nav/style'
import {Button} from '@/components/ui/button/Button'
import {ChevronLeftIcon, ChevronRightIcon, XCloseIcon} from '@/components/ui/icon/Icon'
import {formatLocaleDate} from '@/dayjs'
import {NavProps, useDayPicker} from 'react-day-picker'
import {useState} from 'react'
import dayjs from 'dayjs'
import {InputSelect} from '@/components/commons/input-select/InputSelect'
import {capitalize} from '@/utilities/helpers'

export const CalendarNav = (
    props: Omit<NavProps, 'onSelect'> & {onSelect: (date: Date, closeCalendarAfterSelect?: boolean) => void}
) => {
    const dayPicker = useDayPicker()
    const {months} = dayPicker
    const [isMonthYearSelectorOpen, setIsMonthYearSelectorOpen] = useState(false)
    const currentMonth = months[0].date

    const handleYearChange = (value: string) => {
        const newYear = parseInt(value, 10)
        const newDate = dayjs(currentMonth).year(newYear).toDate()
        props.onSelect(newDate, false)
        dayPicker.goToMonth(newDate) // this is used to trigger the month change event
    }

    const handleMonthChange = (value: string) => {
        const newMonth = parseInt(value, 10)
        const newDate = dayjs(currentMonth).month(newMonth).toDate()
        props.onSelect(newDate, false)
        dayPicker.goToMonth(newDate) // this is used to trigger the month change event
    }

    const getYearOptions = (): [string, string][] => {
        return Array.from({length: 110}, (_, i) => {
            const year = dayjs().year() - 100 + i
            return [year.toString(), year.toString()]
        })
    }

    const getMonthOptions = (): [string, string][] => {
        return Array.from({length: 12}, (_, i) => {
            return [i.toString(), capitalize(formatLocaleDate(dayjs().month(i).toDate(), 'MMMM'))]
        })
    }

    return (
        <StyledCalendarNav>
            <Button type="button" variant="ghost" shape="square" size="lg" onClick={props.onPreviousClick}>
                <ChevronLeftIcon />
            </Button>
            {isMonthYearSelectorOpen ? (
                <StyledCalendarNavMonthYearSelectorsGrid>
                    <InputSelect
                        value={dayjs(currentMonth).month().toString()}
                        onChange={handleMonthChange}
                        optionsEntries={getMonthOptions()}
                        sameWidth={false}
                        hasItemCheckbox={false}
                    />
                    <InputSelect
                        value={dayjs(currentMonth).year().toString()}
                        onChange={handleYearChange}
                        optionsEntries={getYearOptions()}
                        hasItemCheckbox={false}
                        sameWidth
                    />
                    <Button
                        variant="ghost"
                        shape="text"
                        size="sm"
                        onClick={() => setIsMonthYearSelectorOpen(!isMonthYearSelectorOpen)}
                    >
                        <XCloseIcon />
                    </Button>
                </StyledCalendarNavMonthYearSelectorsGrid>
            ) : (
                <StyledCalendarMonthTitle
                    size="textMd"
                    weight="500"
                    onClick={() => setIsMonthYearSelectorOpen(!isMonthYearSelectorOpen)}
                >
                    {formatLocaleDate(months[0].date, 'MMMM YYYY')}
                </StyledCalendarMonthTitle>
            )}
            <Button type="button" variant="ghost" shape="square" size="lg" onClick={props.onNextClick}>
                <ChevronRightIcon />
            </Button>
        </StyledCalendarNav>
    )
}
